import fontDials from './fontDials';
import fontSize from './fontSize';
import FONT_WEIGHTS from '../../../../../constants/font/weights';
import getWeightSizes from '../utils/getWeightSizes';

const DEFAULT_FONT_WEIGHT = 400;
const NUMBER_REGEXP = /^\d+$/;

function fontFamily(family) {
  const dial = this.mapPropValue('fontDial', family);
  return (dial && dial.family) || family;
}

function isValidWeight(w) {
  return (typeof w === 'number' && Number.isFinite(w)) ||
    (typeof w === 'string' && NUMBER_REGEXP.test(w));
}

function fontWeight(value) {
  if (FONT_WEIGHTS.indexOf(value) === -1) {
    return value;
  }

  const rawWeight = this.mapPropValue('fontDial', `${this.base.fontFamily || 'primary'}.weight`);
  const weight = isValidWeight(rawWeight) ? rawWeight : DEFAULT_FONT_WEIGHT;
  const rawWeights = this.mapPropValue('fontDial', `${this.base.fontFamily || 'primary'}.weights`);

  return getWeightSizes(weight, Array.isArray(rawWeights) ? [...rawWeights] : [])[value];
}

function hasFontSet(fonts = [], targetFont = 'old-standard-tt') {
  return fonts.find(font => font === targetFont);
}

export default {
  ...fontDials,
  ...fontSize,
  fontFamily,
  fontWeight,
  hasFontSet
};
